import { Box, Button, Center, FormControl, FormLabel, HStack, Stack } from '@chakra-ui/react';
import { AddIcon, DeleteIcon } from '@chakra-ui/icons';
import usePipelineStore from '../../../stores/pipeline-store';
import { useCallback } from 'react';
import { DrawerSelect, DrawerTextarea } from './inputs';

type StepDrawerLogsAccordionItemProps = {
    stepId: string;
};
export function StepDrawerLogsAccordionItem({
    stepId,
}: StepDrawerLogsAccordionItemProps) {
    const { pipeline, updateStep } = usePipelineStore((state) => state);
    const step = pipeline.steps[stepId] as PipelineStep;

    const addLogItem = useCallback(() => {
        let logsMsgs = step.logsMsgs
            ? (JSON.parse(JSON.stringify(step.logsMsgs)) as any)
            : [];
        if (!logsMsgs) logsMsgs = [];
        logsMsgs.push({
            level: "info",
            timing: "before",
            message: "",
            payload: [],
        });
        updateStep(stepId, "logsMsgs", logsMsgs);
    }, [pipeline, updateStep]);

    const setLogItem = useCallback(
        (index: number, item: NonNullable<typeof step.logsMsgs>[number]) => {
            const logsMsgs = JSON.parse(JSON.stringify(step.logsMsgs ?? [])) as NonNullable<typeof step.logsMsgs>;
            logsMsgs[index] = item;
            updateStep(stepId, "logsMsgs", logsMsgs);
        },
        [stepId, step.logsMsgs, updateStep]
    );

    const deleteLogItem = useCallback(
        (index: number) => {
            const logsMsgs = JSON.parse(JSON.stringify(step.logsMsgs ?? [])) as NonNullable<typeof step.logsMsgs>;
            logsMsgs.splice(index, 1);
            updateStep(stepId, "logsMsgs", logsMsgs);
        },
        [stepId, step.logsMsgs, updateStep]
    );

    return (
        <Box mx={-3}>
            {step.logsMsgs?.map((item, index) => (
                <Box border="1px" borderColor={"gray.200"} padding={5} mb={2}>
                    <HStack>
                        <Button
                            w={"1"}
                            backgroundColor="white"
                            _hover={{ color: "#f0706e" }}
                            _focus={{
                                backgroundColor: "white",
                            }}
                            _active={{
                                backgroundColor: "white",
                            }}
                            color={"grey"}
                            leftIcon={<DeleteIcon />}
                            onClick={() => {
                                deleteLogItem(index);
                            }}
                        ></Button>
                        <Stack flex={1}>
                            <FormControl mt={2}>
                                <FormLabel>Level</FormLabel>
                                <DrawerSelect
                                    value={item.level ?? 'info'}
                                    onChange={(e) => {
                                        const logItem = JSON.parse(JSON.stringify(item));
                                        logItem.level = e.target.value;
                                        setLogItem(index, logItem);
                                    }}
                                >
                                    <option value="error">Error</option>
                                    <option value="warn">Warn</option>
                                    <option value="info">Info</option>
                                    <option value="cp">Control Panel</option>
                                </DrawerSelect>
                            </FormControl>
                            <FormControl mt={2}>
                                <FormLabel>Message</FormLabel>
                                <DrawerTextarea
                                    dir={/[\u0590-\u05FF]/.test(item.message) ? 'rtl' : 'ltr'}
                                    placeholder=""
                                    id="step-description"
                                    autoComplete="off"
                                    aria-describedby="password-helper-text"
                                    value={item.message}
                                    onChange={(e) => {
                                        const logItem = JSON.parse(JSON.stringify(item));
                                        logItem.message = e.target.value;
                                        setLogItem(index, logItem);
                                    }}
                                />
                            </FormControl>
                            <FormControl mt={2}>
                                <FormLabel>Timing</FormLabel>
                                <DrawerSelect
                                    value={item.timing ?? 'before'}
                                    onChange={(e) => {
                                        const logItem = JSON.parse(JSON.stringify(item));
                                        logItem.timing = e.target.value;
                                        setLogItem(index, logItem);
                                    }}
                                >
                                    <option value="before">Before step</option>
                                    <option value="after">After step</option>
                                </DrawerSelect>
                            </FormControl>
                        </Stack>
                    </HStack>
                </Box>
            ))}
            <Center>
                <Button
                    backgroundColor="white"
                    _hover={{
                        backgroundColor: "white",
                        color: "black",
                    }}
                    _focus={{ backgroundColor: "white" }}
                    _active={{ backgroundColor: "white" }}
                    color={"grey"}
                    leftIcon={<AddIcon />}
                    onClick={addLogItem}
                >
                    Add log message
                </Button>
            </Center>
        </Box>
    );
}
